import { Component, OnInit, ViewChild, ElementRef, Input, SimpleChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ActivatedRoute, ROUTER_CONFIGURATION, Router } from '@angular/router';
import { ClientCreditsService } from 'src/app/services/apiclient/clientcredits/clientcredits.service';
import * as _ from "lodash";
import { cloneDeep } from 'lodash';
import { PaymentMethodsComponent } from 'src/app/components/dialogs/payment-methods/payment-methods.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { PayzenComponent } from 'src/app/components/dialogs/payzen/payzen.component';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { TranslateService } from '@ngx-translate/core';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { PaymentsMethodsCardComponent } from 'src/app/components/dialogs/payments-methods-card/payments-methods-card.component';
import { loadStripe } from '@stripe/stripe-js';
import { MyPosComponent } from 'src/app/components/my-pos/my-pos.component';
import * as moment from 'moment';
import { CapturedPaymentComponent } from 'src/app/components/captured-payment/captured-payment.component';
import { NeptingService } from 'src/app/services/apiclient/nepting/nepting.service';
import { Location } from '@angular/common';
import { StripeWebComponent } from 'src/app/components/stripe-web/stripe-web.component';
declare var Stripe: any;

@Component({
  selector: 'app-credits-due',
  templateUrl: './credits-due.component.html',
  styleUrls: ['./credits-due.component.css']
})
export class CreditsDueComponent implements OnInit {
  @Input("selectedTabIndex") visible: any;
  @Input("savedDataBanco") savedDataBanco: any;

  @ViewChild('paypal')
  paypalElement!: ElementRef;

  currCard$: any;

  client_creditsToPay$: any;
  client_credit: any;
  loader: boolean = true;

  currMerchant: any;
  disabled: boolean = false;

  stripe: any;
  clientCards$!: any[];

  credit_pay_intent!: {};

  statusMessageloader = "loader_credit";
  clientAccount: any;
  merchantId: any;
  anchorUnsuccess: any
  @Output() changeTabEvent = new EventEmitter<any>();
  @Output() changeTabstripeEvent = new EventEmitter<any>();
  error: string | any;

  selectedValue: string | any;
  clientCumul = 0;
  currPOS: any;
  payType: any;
  currPaymentChoice: any;

  //paymentsuccess
  savedDataStripe$: any;
  payment_intent$: any;
  nowPayment: any;
  obserProgress: any;
  stopProgress: boolean = false;
  paiment_order_exist: boolean = false;
  maxcall = 0
  constructor(
    private media: MediaObserver,
    private ClientCreditsService: ClientCreditsService,
    private tools: ToolsService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private cardApi: MyStripeService,
    private elementRef: ElementRef,
    private clientAccountApi: ClientaccountService,
    public translate: TranslateService,
    private ref: ChangeDetectorRef,
    private clientMerchantApi: ClientMerchantsService,
    private myStripeApi: MyStripeService,
    public NeptingService: NeptingService,
    private location: Location
  ) { }

  ngOnInit() {
    this.init();
  }
  ngOnDestroy(): void {
    if (this.obserProgress) {
      this.obserProgress.unsubscribe();
    }
  }

  init(unsuccess_getBalance?: any) {
    //nepting card
    this.checkNepting();
    this.checkPaymentIntent();
    /**
  * Check si Yavin paiement
  */
    this.checkPaymentYavin();
    /*** Récupère la current carte client ***/
    this.cardApi.getCurrCard().subscribe(card => {
      this.currCard$ = card;
    });

    /*** Récupère les cartes client***/
    this.cardApi.getPaymentMethod().subscribe((cards: any) => {
      this.clientCards$ = cards;
    });
    /*** Récupère les params de la page ***/
    this.route.params.subscribe(params => {
      this.merchantId = params['merchantId'] ? params['merchantId'] : null;
      if (this.merchantId) {
        this.clientMerchantApi.getMerchant(params['merchantId']).subscribe(merchant => {
          this.currMerchant = merchant;
        })
      }
      this.tools.setPageClient("credits");
      this.getCreditsTopay(this.merchantId, unsuccess_getBalance);
    });

    /*** Récupère la fiche client account du client connecté ** */
    this.clientAccountApi.getClientAccount().subscribe(data => {
      this.clientAccount = data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['savedDataBanco'] && changes['savedDataBanco'].currentValue) {
      this.client_credit = changes['savedDataBanco'].currentValue;
    }
  }

  getPointOfsale() {
    let currpos = this.client_creditsToPay$.find((value: any) => (value.key == this.selectedValue));
    this.currPOS = currpos ? currpos : null;
  }

  pofChange($ev?: any) {
    this.getPointOfsale();
    this.client_credit = null;
    this.resetAllComplete()
  }

  // Check params
  checkNepting() {
    this.route.params.subscribe((params: any) => {
      //nepting
      if (params.nepting && params.payment) {
        if (params.payment == "success") {
          this.changestate(params);
          this.successPaymentCredit(params.payment)
          return;
        }
        else if (params.payment == "cancel" || params.payment == "error" || params.payment == "refused") {
          this.translate.get("nepting." + params.payment).subscribe((trad: string) => {
            this.tools.openSnackBar(trad, "warn", 2000);
          })
          this.changestate(params);
        }
      }
    })
  }

  changestate(params: any) {
    let url = 'home/credits'
    if (params.merchantId) {
      url += '/' + params.merchantId;
    }
    this.location.replaceState(url);
  }

  // Vérifie si on vient d'une redirection apres un paiement stripe element
  checkPaymentIntent(): void {
    const url = new URL(window.location.href);
    const clientSecret = url.searchParams.get('payment_intent_client_secret');
    const status = url.searchParams.get('redirect_status');
    const that = this;
    this.savedDataStripe$ = that.tools.getStor("payment_credit_stripe_payment");

    if (clientSecret) {
      that.loader = true;
      // On récupère les données essentielles qui ont été sauvegardées avant la redirection vers le paiement
      this.payment_intent$ = url.searchParams.get('payment_intent');
      if (this.savedDataStripe$) {
        if (status === "succeeded") {
          this.nowPayment = moment();
          this.progressPaymentObservable();
          that.myStripeApi.setProgressPaymentStripe(true);
        }
        else {
          that.loader = false;
          this.savedDataStripe$ = null;
          that.tools.removeStor("payment_credit_stripe_payment");
          that.goSame();
        }
        return;
      }
    }
    else {
      if (this.savedDataStripe$) {
        //check
        this.checkLetteringPayment();
      } else {
        //page refresh
        that.tools.removeStor("payment_credit_stripe_payment");
      }
    }
  }

  checkPaymentYavin(): void {
    const url = new URL(window.location.href);
    const yavin = url.searchParams.get('cartId');
    const status = url.searchParams.get('status');
    const that = this;
    if (yavin) {
      //**********  status possible***********
      // pending : En attente de paiement.
      // ok : Paiement réussi.
      // authorised : Payé mais contient une ou plusieurs transactions autorisées nécessitant une capture.
      // ko : Le panier a été annulé.
      //status !== 'ko'
      let Payments_type_Storage: any = this.tools.getStor('Payments_type');
      if (status == 'ok' || status == 'authorised' && Payments_type_Storage && Payments_type_Storage[0].payment_type == "yavin") {
        that.ClientCreditsService.yavinCreditPaymentSucceeded(yavin, status, Payments_type_Storage[0].key).then((data: any) => {
          if (data && data.code == 0) {
            that.successPaymentCreditStripe();
          }
          else {
            that.goSame();
          }
        });
      }
      else {
        that.loader = false;
        that.goSame();
      }
      return;
    }
  }

  goSame(): void {
    this.tools.openSnackBar(this.translate.instant('booking.error_pay'), "warn", 10000);

    const url = window.location.pathname;
    this.router.navigate([url]);
  }

  // get Credits To pay
  getCreditsTopay(merchantId?: any, unsuccessApiGetBalance?: any) {
    if (unsuccessApiGetBalance)
      this.resetUnsuccessApiGetBalance();
    this.statusMessageloader = "loader_credit";
    this.ClientCreditsService.getCreditstoPay(merchantId).subscribe((creditstopay_value: any) => {
      this.client_creditsToPay$ = this.transformGroup(creditstopay_value, (val: any) => val.id_point_of_sale);
      if (!this.client_creditsToPay$[0].point_of_sale || !this.client_creditsToPay$[0].pay_online) {
        return;
      }
      this.selectedValue = this.client_creditsToPay$[0].point_of_sale ? this.client_creditsToPay$[0].point_of_sale.id : null;
      this.getPointOfsale();
      //on set les paiments type
      this.Payments_type();
      // bancontact error on set a nouveau et on scroll
      if (this.client_credit)
        this.setcreditCkeckBox();
      //si error -1199
      if (unsuccessApiGetBalance) {
        //messages erreur get balance
        this.unsuccessApiGetBalance();
      }
    });
  }

  // transformGrou
  transformGroup(array: any, valueGroup: any) {
    array.forEach((element: any) => { element.completed = false; });
    let group = _.groupBy(array, valueGroup);
    let result = Object.keys(group).map(key => ({ key, value: group[key], allcompleted: false, cumul: 0, pay_online: false }))
    let resultOnlinePaymethod = this.OnlinePaymethod(result);
    this.loader = false;
    return resultOnlinePaymethod;
  }

  // get Online Payment method
  OnlinePaymethod(result: any) {
    let Payments_type_Storage: any = this.tools.getStor('Payments_type');
    result.forEach((group: any) => {
      let elementPos = null;
      if (Payments_type_Storage) {
        elementPos = Payments_type_Storage.map(function (x: any) { return x.key; }).indexOf(group.key);
        elementPos = elementPos.toString();
      }
      if (group.value) {
        const ele = group.value[0];
        if (ele.point_of_sale.paypal_account || ele.point_of_sale.stripe_account || ele.point_of_sale.payzen_account ||
          ele.point_of_sale.yavin_account || ele.point_of_sale.mypos_account
        ) {
          group.pay_online = true;
          group.payment_type = (this.clientCards$ && this.clientCards$.length > 0) && ele.point_of_sale.stripe_account ? "online" :
            ele.point_of_sale.paypal_account ? "online_paypal"
              : ele.point_of_sale.payzen_account ? "payzen" :
                ele.point_of_sale.stripe_account ? "online" :
                  ele.point_of_sale.mypos_account ? "myPos" :
                    ele.point_of_sale.yavin_account ? "yavin" :
                      null;

          // paiement type in storage
          if (elementPos && elementPos !== "-1" && Payments_type_Storage) {
            let posiblePaymenttype: any = {
              "online": ele.point_of_sale.stripe_account ? true : false,
              "online_paypal": ele.point_of_sale.paypal_account ? true : false,
              "payzen": ele.point_of_sale.payzen_account ? true : false,
              "myPos": ele.point_of_sale.mypos_account ? true : false,
              "yavin": ele.point_of_sale.yavin_account ? true : false
            };
            let paymentTypeStorage = Payments_type_Storage[elementPos].payment_type;
            group.payment_type = posiblePaymenttype[paymentTypeStorage] ? paymentTypeStorage : group.payment_type;
          }
          // test bancontact ele.point_of_sale.country.id = 22;
          group.point_of_sale = ele.point_of_sale;
          //onset
          this.payType = group.payment_type;
        };
      }
    });
    return result;
  }

  // set credit CkeckBox
  setcreditCkeckBox() {
    let elementPos = this.client_creditsToPay$.map(function (x: any) { return x.key; }).indexOf(this.client_credit.key);
    if (elementPos && elementPos != -1) {
      this.client_creditsToPay$[elementPos] = this.client_credit;
      this.handlePaymentMethods();
      this.scrollTo(this.client_credit.anchor);
    }
  }

  // scrollTo element
  scrollTo(element: any): void {
    setTimeout(() => {
      (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }, 0);
  }

  ////////// Check Box //////////
  setAllComplete(completed: boolean, obj: any, i: any) {
    this.resetAllComplete();
    obj.allcompleted = completed;
    obj.anchor = 'content-' + i;
    this.setValueComplete(obj, completed);
  }

  updateComplete(obj: any, i: any) {
    obj.allcompleted = obj.value.every((t: any) => t.completed);
    obj.anchor = 'content-' + i;
    this.resetAllComplete(obj);
    this.setValueComplete(obj);
  }

  resetAllComplete(val?: any) {
    this.client_creditsToPay$.forEach((element: any) => {
      if (!val || (val && element.key != val.key)) {
        element.cumul = 0;
        element.allcompleted = false;
        element.value.forEach((c: any) => {
          c.completed = false;
        });
      }
    });
  }

  setValueComplete(obj: any, completed?: any) {
    obj.cumul = 0;
    obj.value.forEach((c: any) => {
      if (completed && !c.lettering_payment) { c.completed = completed; }
      if (c.completed) { obj.cumul += c.value; }
    });
    this.client_credit = obj;
    this.clientCumul = obj.cumul;
    this.handlePaymentMethods();
  }

  // Check les methodes de paiement valides
  handlePaymentMethods(): void {
    const pos = this.client_credit.point_of_sale;
    const currency = pos.currency;
    this.client_credit.pos_id = pos.id;
    let client_val = this.client_credit.value[0];
    this.client_credit.merchant_id = client_val.id_user;

    if (pos.paypal_account) { // si compte paypal
      this.initScriptPaypal(currency, pos.paypal_account);
      this.modeltosend();
    }

    if (pos.stripe_account) { //si compte stripe
      this.cardApi.getStripeKey().subscribe(async key => {
        if (key)
          this.stripe = await loadStripe(key);
      });
    }
  }

  // Initialise le sdk paypal
  initScriptPaypal(currency: any, paypalAccountId: any): void {
    var s = document.createElement("script");
    s.src = "https://www.paypal.com/sdk/js?client-id=" + paypalAccountId + "&currency=" + currency.shortname;
    this.elementRef.nativeElement.appendChild(s);
  }

  // setClientCards
  setClientCards(cards: any) {
    this.clientCards$ = cards;
  }

  // Ouvre la dialog de selection de methode de paiement
  openPaymentMethodsDial(obj: any): void {
    this.client_credit = obj;
    const myConf = new MatDialogConfig();
    myConf.data = {
      clientCards: this.clientCards$,
      currMerchant: obj.point_of_sale,
      payment_type: obj.payment_type,
      popupMode: true
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");
    const myDial = this.dialog.open(PaymentMethodsComponent, myConf);
    this.tools.setOnPopState(true);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        this.setClientCards(result.cards);
        this.setPaymentType(result.payment_method);
      }
    });
  }

  //Ouvre la dialog card
  openCardMethodsDial(ev: any) {
    if (this.client_credit) {
      const myConf = new MatDialogConfig();
      myConf.data = {
        clientCards: this.clientCards$,
        card: ev,
        pos: this.client_credit.point_of_sale,
      };
      this.media.isActive("xs")
        ? (myConf.width = "100%", myConf.height = "100%")
        : (myConf.width = "550px", myConf.height = "80%");
      const myDial = this.dialog.open(PaymentsMethodsCardComponent, myConf);
      this.tools.setOnPopState(true);
      myDial.afterClosed().subscribe((result) => {
        if (result) {
          this.setClientCards(result.cards);
          this.setPaymentType(result.payment_method);
        }
      });
    }
  }

  //Set le choix de paiement provient emi autre components
  setPaymentChoice_(paymentChoice: any) {
    if (paymentChoice)
      this.setPaymentType(paymentChoice);
  }

  //Set le choix de paiement (Stripe ou paypal)
  setPaymentType(paymentType?: string): void {
    if (paymentType && this.client_credit) {
      this.client_credit.payment_type = paymentType;
      this.currPaymentChoice = this.client_credit.payment_type
      this.handlePaymentMethods();
      this.Payments_type();
    }
    else {
      this.client_creditsToPay$.forEach((element: any) => {
        element.payment_type = paymentType
      });
    }
  }

  // set model to send
  modeltosend() {
    let value = [];
    this.client_credit.ids = [];
    this.client_credit.value.forEach((element: any) => { if (element.completed) { this.client_credit.ids.push(element.id); value.push(element); } });
    let ojbCloned = cloneDeep(this.client_credit);

    this.credit_pay_intent = {
      amount: (ojbCloned.cumul * -1),
      list: ojbCloned.ids,
      merchant_id: ojbCloned.merchant_id,
      pos_id: ojbCloned.pos_id,
      value: ojbCloned.value,
      payment_type: ojbCloned.payment_type
    }
  }

  // set Payments_type
  Payments_type() {
    let arrayPaymentType: any = [];
    if (this.client_creditsToPay$) {
      this.client_creditsToPay$.forEach((element: any) => {
        if (element.payment_type) {
          arrayPaymentType.push({
            key: element.key,
            payment_type: element.payment_type
          });
        }
      });
      this.tools.setStor('Payments_type', arrayPaymentType);
    }
  }

  // beforeSubmitPay
  SubmitPay(obj: any) {
    if (obj.payment_type && obj.cumul < 0) {
      this.modeltosend();
      obj.payment_type === 'stripe' ? this.openStripePayment() :
        this.submitPayCredit();
    }
  }

  /////////// submit_pay - Stripe - Payzen - banco //////////
  // envoie les infos de paiement stripe - payzen - banco
  submitPayCredit(payment_intent_id?: string) {
    const that = this;
    that.loader = true;
    that.statusMessageloader = "loader_trai";
    let paypal_order_id: any = null;

    that.ClientCreditsService.creditCard(that.credit_pay_intent, that.currCard$, paypal_order_id, payment_intent_id).then(data => {
      /*** stripe ***/
      if (data && data.code === 0) {
        that.successPaymentCredit(data);
      }
      else if (data && data.code === -2) {
        /*** stripe 3d ***/
        this.tools.setStor("ClientKeyPayIntenCard", data.pi);
        that.stripe.handleCardAction(data.payment_intent_client_secret
        ).then(function (result: any) {
          if (result.error) {
            that.tools.openSnackBar(result.error.message, "warn", 10000);
            that.loader = false;
          } else {
            that.confirmPayCreditStripe(result.paymentIntent.id);
          }
        });
      }
      else if (data.code == -3) {
        this.tools.setStor("ClientKeyPayIntenCard", data.pi);
        //3d secure
        that.stripe.confirmCardPayment(
          data.payment_intent_client_secret,
          {
            payment_method: data.pi.payment_method,
          },
        ).then(function (result: any) {
          if (result.error) {
            that.tools.openSnackBar(result.error.message, "warn", 10000);
            that.loader = false;
          } else {
            if (result.paymentIntent.status == "succeeded") {
              that.confirmPayCreditStripe(result.paymentIntent.id);
            };
          }
        })
      }

      /*** Payzen ***/
      else if (data && data.code === -5) {
        that.openPayzenCard(data);
      }
      /*** Bancontact ****/
      else if (data && data.code === -4) {
        // Sauvegarde le lettering credit  pour la redirection de paiement (bancontact)
        data.credit = that.client_credit;
        that.tools.setStor('payment_save_banco_credit', data);
        that.stripe.confirmBancontactPayment(
          data.pi_bancontact.client_secret,
          {
            payment_method: {
              billing_details: {
                name: that.clientAccount.firstname + " " + that.clientAccount.lastname,
                email: that.clientAccount.mail,
              },
            },
            return_url: window.location.origin + window.location.pathname,
          }
        ).then(function (result: any) {
          if (result.error) {
            // Inform the customer that there was an error.
          }
        });
      }
      /*** yavin ****/
      else if (data && data.code === -89) {
        window.location.href = data.yavin_link.payment_link;
        return;
      }
      /*** Mypos ****/
      else if (data && data.code === -9) {
        if (data.mypos_account) {
          // on ouvre le pop_up
          that.openMyPosPayment(data);
        }
        else {
          this.tools.openSnackBar(data.message ? data.message : "Une erreur s'est produite, veuillez réessayer ultérieurement", "warn", 10000);
          this.loader = false;
        }
      }
      // nepting
      else if (data.code === -90) {
        this.NeptingService.getForm(data);
      }
      /*** error ****/
      else if (data && data.code === -1199) {
        // error api get balance : on reactualise les nouvelles infos avec messages error
        this.init(data.code);
      }
      else if (data && data.code && data.code === -1000) {
        if (data.err && data.err.jsonBody && data.err.jsonBody && data.err.jsonBody.error && data.err.jsonBody.error.message) {
          data.message = "Une erreur s'est produite (3d_secure) "
          // data.message += "(" + data.err.jsonBody.error.message + ")";
          data.message += " \n \n   Veuillez utiliser Stripe";
        }
        this.tools.openSnackBar(data.message ? data.message : "Une erreur s'est produite, veuillez réessayer ultérieurement", "warn", 10000);
        this.loader = false;
      }
      else if (data && data.code && data.code === -134) {
        this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
        this.loader = false;
      }
      else if (data && data.code && data.code == -60) {
        //pas de client
        this.tools.openSnackBar(this.translate.instant('nocustomers'), ['warn'], 4000);
        this.loader = false;
      }
    });
  }

  // confirm Pay avec  payment_intent_id 3d secure
  confirmPayCreditStripe(payment_intent_id?: string) {
    this.submitPayCredit(payment_intent_id);
  }

  ////////// submit_pay Paypal /////////
  // envoie les infos de paypal
  paypalEmited(paypal_order_id: any) {
    this.submitPaypalPayCredit(paypal_order_id);
  }

  submitPaypalPayCredit(paypal_order_id?: any) {
    const that = this;
    that.statusMessageloader = "loader_trai";
    that.loader = true;

    that.ClientCreditsService.creditCard(this.credit_pay_intent, this.currCard$, paypal_order_id).then(
      data => {
        /*** Success ***/
        if (data.code === 0) {
          that.successPaymentCredit(data);
          that.loader = false;
          that.ref.detectChanges();
        }
        /*** error ****/
        else if (data.code === -1199) {
          // error api get balance
          //on reactulaise les nouvelles infos avec messages error
          this.init(data.code);
        }
        /*** Erreur ***/
        else {

          if (data && data.code && data.code === -134) {
            this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
            this.loader = false
          }
          else {
            if (data && data.code && data.code == -60) {
              //pas de client
              data.message = this.translate.instant('nocustomers');
            }
            that.tools.openSnackBar(data.message, "warn", 10000);
            this.loader = false;
          }
        }
      }
    );
  }

  //////// StripePayment ////////
  openStripePayment(payment_intent_id?: any): void {
    let that: any = this;
    let dataCredit: any = {
      credit_pay_intent: this.credit_pay_intent,
      currCard$: this.currCard$,
      payment_intent_id: payment_intent_id
    }
    this.loader = true;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      amount: that.credit_pay_intent.amount,
      id_user: that.credit_pay_intent.merchant_id,
      metadata: 2,//provenance credit
      dataCredit: dataCredit,
      stripe: this.stripe,
      currpos: this.currPOS
    };

    const myDial = this.dialog.open(StripeWebComponent, myConf);
    myDial.afterClosed().subscribe((result: any) => {
      this.tools.setOnPopState(true);
      this.loader = false;
      if (!result || result && result.error) {
        this.tools.removeStor("payment_credit_stripe_payment");
        //this.cardApi.resetPaymentElement();
        if (result && result.error)
          this.openDialogStatusStripeCapuredSucceded(result.error);
      }
    });
  }

  ////////// error payintent captured ////////
  openDialogStatusStripeCapuredSucceded(error?: any) {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.disableClose = true;
    myConf.data = {
      error: error,
      credit: true
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "80%", myConf.height = "80%");
    const myDial = this.dialog.open(CapturedPaymentComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      this.tools.removeStor("ClientKeyPayIntentCredit");
    })
  }

  ////////// myPos /////////
  openMyPosPayment(data?: any, payment_intent_id?: any): void {
    let that: any = this;
    let dataCredit: any = {
      credit_pay_intent: that.credit_pay_intent,
      currCard$: that.currCard$,
    }
    that.loader = true;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      amount: that.credit_pay_intent.amount,
      id_user: that.credit_pay_intent.merchant_id,
      metadata: 2,//provenance credit
      dataCredit: dataCredit,
      mypos_account: data.mypos_account,
      lettering_intent_id: data.lettering_intent_id
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");
    const myDial = this.dialog.open(MyPosComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      this.tools.setOnPopState(true);
      if (result && result.success) {
        this.loader = true;
        this.setPaymentMypos(result.success.OrderID, result.success);
      }
      else {
        this.loader = false;
      }
    });
  }

  setPaymentMypos(order_id: any, paiement: any) {
    let that = this;
    that.ClientCreditsService.setPaymentCreditMypos(paiement, order_id).then(credit => {
      if (credit && credit.code === 0) {
        that.successPaymentCredit(credit);
      }
      else {
        this.tools.openSnackBar(this.translate.instant('booking.error_pay'), "warn", 5000);
        this.loader = false;
        //error
      }
    }).catch(err => {
      console.error('err', err)
    })
  }

  ////// Payzen //////
  // ouvre la pop up card paiement (Payzen)
  openPayzenCard(value: any): void {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = { data: value };

    this.media.isActive('xs') ? myConf.width = '100%' : myConf.width = '500px';
    const myDial = this.dialog.open(PayzenComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (document.getElementById('krtoolbar')) {
        let krtoolbar: any = document.getElementById('krtoolbar')
        krtoolbar.style.display = 'none';
      }
      if (result)
        this.setPaymentPayzen(result.paiement.clientAnswer, value.lettering_intent_id);
      this.loader = false;
    });
  }

  //setPaymentPayzen
  setPaymentPayzen(paiement: any, id_lettering?: any) {
    const that = this;
    that.ClientCreditsService.setPaymentPayzen(paiement, id_lettering).then(data => {
      if (data.code === 0)
        that.successPaymentCredit(data);
      else {
        this.tools.openSnackBar(this.translate.instant('booking.error_pay'), "warn", 5000);
        this.loader = false;
      }
    }).catch(err => {
      console.error('err', err);
    });
  }

  /////// nepting //////
  // payment accepté et redirection
  successPaymentCredit(data: any) {
    this.tools.openSnackBar(this.translate.instant('credit_due.success_payment'), ['great'], 5000);
    this.loader = false;
    this.tools.setStor("payment_credit", data);
    this.changeTabEvent.emit();
  }

  //payment accepté et redirection stripe
  successPaymentCreditStripe(data?: any) {
    const url = window.location.pathname;
    let that = this
    that.router.navigate([url]);
    that.tools.openSnackBar(this.translate.instant('credit_due.success_payment'), ['great'], 5000);
    that.loader = false;
    this.tools.removeStor("payment_credit_stripe_payment");
    this.tools.removeStor("ClientKeyPayIntentCredit");
    that.changeTabstripeEvent.emit("stripe");
  }

  resetUnsuccessApiGetBalance() {
    this.anchorUnsuccess = this.client_credit && this.client_credit.anchor ? this.client_credit.anchor : null;
    this.client_credit = null;
    this.resetAllComplete()
  }

  unsuccessApiGetBalance() {
    if (this.anchorUnsuccess)
      this.scrollTo(this.anchorUnsuccess);
    this.tools.openSnackBar(this.translate.instant('credit_due.unsuccess_getBalance'), ['warn'], 8000);
    this.loader = false;
  }

  goBack(): void {
    this.router.navigate(["/home/merchantOptions/" + this.currMerchant.id_user]);
  }

  goPrintTicket(link: string) {
    window.open(link);
  }

  // observable  Payment Stripe
  progressPaymentObservable() {
    this.obserProgress = this.myStripeApi.getProgressPaymentStripe().subscribe(value => {
      if (value && this.savedDataStripe$ && this.payment_intent$)
        this.getProgressPayment();
    });
  }

  // check in order payment -> captured
  getProgressPayment() {
    // table lettering-payment
    this.maxcall++;
    this.myStripeApi.getLetteringPaymentStripe(this.savedDataStripe$.lettering_intent_id, this.payment_intent$).then((data: any) => {
      let time_Exceeded = this.maxcall > 10 ? true : this.myStripeApi.checkTimeExceeded(this.nowPayment);
      if (data && data.code < 0 || time_Exceeded || data.creditPayment && data.creditPayment.captured && data.creditPayment.captured == 1) {
        //stop intervall
        this.myStripeApi.stopIntervalProgressPayment();
        //message ok ou ko
        this.finalStatusBeforeClose(data);
      }
      else {
        //start call
        this.myStripeApi.startIntervalProgressPayment();
      }
      return;
    });
  }

  // Status Before Close
  finalStatusBeforeClose(infoStatus: any) {
    if (this.stopProgress) {
      return;
    }
    //error infoStatus.code <0
    // time out  time_Exceeded let time_Exceeded = this.myStripeApi.checkTimeExceeded(this.nowPayment);
    // captured  infoStatus.orderPayment.captured
    if (infoStatus.creditPayment && infoStatus.creditPayment.captured && infoStatus.creditPayment.captured == 1) {
      this.successPaymentCreditStripe();
    }
    else {
      this.checkLetteringPayment();
    }
  }

  // check in LetteringPayment -> captured if problem
  checkLetteringPayment() {
    this.loader = true;
    this.myStripeApi.checkLetteringPayment(this.savedDataStripe$.lettering_intent_id, this.savedDataStripe$.payment_intent).then((data: any) => {
      if (data && data.code >= 0 && (data.creditPayment && data.creditPayment.captured == 1 && data.paiement && data.paiement.status ==
        "succeeded")) {
        this.tools.removeStor("ClientKeyPayIntentCredit");
        this.tools.removeStor("payment_credit_stripe_payment");
        this.savedDataStripe$ = null;
        this.successPaymentCreditStripe();
      }
      else {
        this.loader = false;
        this.tools.removeStor("payment_credit_stripe_payment");
        this.savedDataStripe$ = null;
        this.goSame();
      }
      return;
    });
  }
}
